App.Models.district = class District extends PF.Model {

    get populateExceptions() {
        return {
            border: true
        };
    }
}